import { render } from "./EnderecosPicking.vue?vue&type=template&id=c8706050&scoped=true"
import script from "./EnderecosPicking.vue?vue&type=script&lang=js"
export * from "./EnderecosPicking.vue?vue&type=script&lang=js"

import "./EnderecosPicking.vue?vue&type=style&index=0&id=c8706050&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8706050"]])

export default __exports__